// src/components/features/Planning/pages/ThankYouPage.jsx
import { Box, Flex, Text, VStack } from "@chakra-ui/react";

export default function ThankYouPage() {

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.100">
      <Box
        w={{ base: "100%", md: "400px" }}
        bg="white"
        px={8}
        py={10}
        borderRadius="xl"
        boxShadow="lg"
        textAlign="center"
      >
        <VStack spacing={5}>
          {/* Success Icon */}
          <Box
            w="80px"
            h="80px"
            borderRadius="full"
            bg="green.50"
            border="3px solid"
            borderColor="green.400"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="40px"
          >
            ✓
          </Box>

          {/* Heading */}
          <Text fontSize="22px" fontWeight="700" color="gray.800">
            Thank You!
          </Text>

          {/* Message */}
          <Text fontSize="14px" color="gray.500" lineHeight="1.6">
            Your form has been submitted successfully. Our team will review your
            requirements and get back to you shortly.
          </Text>

          {/* Divider */}
          <Box w="60px" h="3px" bg="cyan.400" borderRadius="full" />

          {/* Sub message */}
          <Text fontSize="13px" color="gray.400">
            You can close this window now.
          </Text>
        </VStack>
      </Box>
    </Flex>
  );
}
